export const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  try {
    return new Date(dateString).toLocaleDateString();
  } catch {
    return "N/A";
  }
};

/**
 * Get current year for copyright
 * @returns {number} Current year
 */
export const getCurrentYear = () => new Date().getFullYear();
